// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__Zz_tP","info":"header_info__y6I5h","sticky":"header_sticky__2LZo8"};